import React from 'react';
import { CheckCircle, Waves, Building, Square, Wrench, Grid3x3 } from 'lucide-react';
import { services } from '../data/mockData';

const iconComponents = {
  Waves: Waves,
  Building: Building,
  Square: Square,
  Wrench: Wrench,
  Fence: Grid3x3
};

const Services = () => {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-hero-title">Our Services</h1>
          <p className="page-hero-subtitle">
            Professional glass fencing and balustrade solutions tailored to your needs
          </p>
        </div>
      </section>

      {/* Services Detail Section */}
      <section className="services-detail-section">
        <div className="container">
          {services.map((service, index) => {
            const IconComponent = iconComponents[service.icon];
            return (
              <div 
                key={service.id} 
                className={`service-detail-card ${index % 2 === 1 ? 'reverse' : ''}`}
              >
                <div className="service-detail-icon">
                  <IconComponent size={48} />
                </div>
                <div className="service-detail-content">
                  <h2 className="service-detail-title">{service.title}</h2>
                  <p className="service-detail-description">{service.description}</p>
                  <ul className="service-detail-features">
                    {service.features.map((feature, idx) => (
                      <li key={idx}>
                        <CheckCircle size={20} />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-section">
        <div className="container">
          <h2 className="section-title">Why Choose Genuine Fencers?</h2>
          <div className="why-choose-grid">
            <div className="why-choose-card">
              <h3>Experience & Expertise</h3>
              <p>Years of experience in glass installations across Sydney, delivering exceptional results on every project.</p>
            </div>
            <div className="why-choose-card">
              <h3>Premium Materials</h3>
              <p>We use only the highest quality 12mm toughened glass and marine-grade stainless steel hardware.</p>
            </div>
            <div className="why-choose-card">
              <h3>Safety Compliance</h3>
              <p>All installations meet or exceed Australian safety standards (AS 1926.1-2012 for pool fencing).</p>
            </div>
            <div className="why-choose-card">
              <h3>Professional Service</h3>
              <p>From initial consultation to final installation, we ensure a smooth and hassle-free experience.</p>
            </div>
            <div className="why-choose-card">
              <h3>Warranty Backed</h3>
              <p>Comprehensive warranties on both materials and workmanship for complete peace of mind.</p>
            </div>
            <div className="why-choose-card">
              <h3>Competitive Pricing</h3>
              <p>Fair, transparent pricing with no hidden costs. Free quotes and on-site consultations.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
